export default function ProjectGallery(){
    return(
        <section id="Gallery">
            {/* <h2>Trailer & Screenshots</h2> */}
        </section>
    )
}